import { RouteObject } from 'react-router-dom';
import HomePage from '@/pages/home/page';
import ServicosPage from '@/pages/servicos/page';
import SobrePage from '@/pages/sobre/page';
import ContatoPage from '@/pages/contato/page';
import FaqPage from '@/pages/faq/page';
import NotFound from '@/pages/NotFound';

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/servicos', element: <ServicosPage /> },
  { path: '/sobre', element: <SobrePage /> },
  { path: '/contato', element: <ContatoPage /> },
  { path: '/faq', element: <FaqPage /> },
  { path: '*', element: <NotFound /> },
];

export default routes;
